<!-- Responsibility: Implement sys section supervisor behavior for the ui/panels surface.
Scope: Owns ui/panels concerns only; cross-surface orchestration is excluded. -->
<sys-section-supervisor>
  <div>
    <h5 class="section-title" style="margin-top:var(--space-lg);">AI SUPERVISOR</h5>
    <p class="perf-note">
      Runtime integrity monitor for game state contracts. Default mode is observe-only; auto-repair should be enabled only after stability validation.
    </p>

    <div class="supervisor-summary">
      <span>runs { props.view?.runs?.length || 0 }</span>
      <span>incidents { props.view?.incidents?.length || 0 }</span>
      <span>pending { props.view?.pendingCount || 0 }</span>
      <span>applied { props.view?.appliedCount || 0 }</span>
    </div>

    <div class="supervisor-controls">
      <button class="action-btn" onclick={ () => props.actions?.runSupervisorNow?.() }>RUN NOW</button>
      <button class="action-btn" onclick={ () => props.actions?.exportSupervisorAudit?.() }>EXPORT AUDIT JSON</button>
      <button class="action-btn" onclick={ () => props.actions?.clearSupervisorAudit?.() }>CLEAR AUDIT</button>
    </div>

    <div class="supervisor-config-grid">
      <label>Enabled
        <select onchange={ (e) => props.actions?.onSupervisorConfigEnabledInput?.(e) }>
          <option value="1" selected={ !!props.view?.enabled }>ON</option>
          <option value="0" selected={ !props.view?.enabled }>OFF</option>
        </select>
      </label>

      <label>Time budget (ms)
        <input type="number" min="5" max="1000" value={ props.view?.timeBudgetMs || 20 } oninput={ (e) => props.actions?.onSupervisorConfigBudgetInput?.(e) }>
      </label>

      <button class="action-btn" onclick={ () => props.actions?.saveSupervisorConfig?.() }>SAVE SUPERVISOR CONFIG</button>
    </div>

    <div class="supervisor-policy-grid">
      <div each={ domain in props.view?.domains } class="supervisor-policy-row">
        <span>{ domain.toUpperCase() }</span>
        <select value={ props.view?.policyDraft?.[domain] || 'observe' } onchange={ (e) => props.actions?.onSupervisorDomainPolicyInput?.(domain, e) }>
          <option value="observe">OBSERVE</option>
          <option value="confirm">CONFIRM</option>
          <option value="auto">AUTO</option>
          <option value="freeze">FREEZE</option>
        </select>
      </div>
    </div>

    <p class="perf-note" if={ props.view?.lastDegraded }>
      last degraded: { props.view.lastDegraded }
    </p>

    <div class="supervisor-filter-row">
      <select value={ props.view?.filterDomain || 'all' } onchange={ (e) => props.actions?.setSupervisorFilterDomain?.(e.target.value) }>
        <option value="all">ALL DOMAINS</option>
        <option each={ domain in props.view?.domains } value={ domain }>{ domain.toUpperCase() }</option>
      </select>
      <select value={ props.view?.filterSeverity || 'all' } onchange={ (e) => props.actions?.setSupervisorFilterSeverity?.(e.target.value) }>
        <option value="all">ALL SEVERITIES</option>
        <option value="critical">CRITICAL</option>
        <option value="high">HIGH</option>
        <option value="medium">MEDIUM</option>
        <option value="low">LOW</option>
      </select>
      <select value={ props.view?.filterStatus || 'all' } onchange={ (e) => props.actions?.setSupervisorFilterStatus?.(e.target.value) }>
        <option value="all">ALL STATUS</option>
        <option value="pending">PENDING</option>
        <option value="applied">APPLIED</option>
        <option value="failed">FAILED</option>
        <option value="ignored">IGNORED</option>
      </select>
    </div>

    <div class="supervisor-incident-list" if={ props.view?.filteredIncidents?.length }>
      <div each={ incident in props.view.filteredIncidents.slice(0, 24) } class="supervisor-incident-row severity-{ incident.severity } status-{ incident.remediationStatus }">
        <div class="supervisor-incident-head">
          <span>{ incident.domain.toUpperCase() } · { incident.severity.toUpperCase() } · { incident.remediationStatus.toUpperCase() }</span>
          <span>{ props.view?.formatTime?.(incident.timestamp) }</span>
        </div>
        <div class="supervisor-incident-msg">[{ incident.code }] { incident.message }</div>
        <div class="supervisor-incident-meta">confidence { Math.round((incident.confidence || 0) * 100) }% · check { incident.checkId || 'n/a' }</div>
        <div class="supervisor-incident-actions">
          <button if={ incident.remediationStatus === 'pending' } class="action-btn" onclick={ () => props.actions?.remediateSupervisorIncident?.(incident.id) }>
            APPLY FIX
          </button>
          <button if={ incident.rollbackSnapshotId } class="action-btn" onclick={ () => props.actions?.rollbackSupervisorSnapshot?.(incident.rollbackSnapshotId) }>
            ROLLBACK
          </button>
        </div>
      </div>
    </div>

    <p if={ !(props.view?.filteredIncidents?.length) } class="perf-note">No incidents for the selected filter.</p>

    <div class="supervisor-runs" if={ props.view?.runs?.length }>
      <div each={ run in props.view.runs.slice(0, 10) } class="supervisor-run-row">
        <div>{ props.view?.formatTime?.(run.startTime) } · { run.reason || 'n/a' }</div>
        <div>{ Math.round(run.durationMs || 0) }ms · incidents { run.incidentsFound || 0 } · repaired { run.incidentsRepaired || 0 }{ run.aborted ? ' · ABORTED' : '' }</div>
      </div>
    </div>

    <p class="perf-note" if={ props.view?.message }>{ props.view.message }</p>
  </div>
</sys-section-supervisor>
